import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TabMenu } from 'primereact/tabmenu';
import { MenuItem } from 'primereact/menuitem';
import { getAction } from '../../../appconfig/AppHelper';

export const FreshApplicationTab = (initialTabLabel: any) => {
    const router = useNavigate();
    const [actions, setActions] = useState<any>([]);


    const HRitems: MenuItem[] = [
        {
            label: 'Fresh Registration',
            command: () => {
                router('/app/application/fresh-registration-list');
            }
        },
        {
            label: 'Fresh Registration Other',
            command: () => {
                router('/app/application/fresh-registration-other-list');
            }
        },
        {
            label: 'Fresh Registration (Transfer To Gujarat)',
            command: () => {
                router('/app/application/fresh-registration-transfer-list');
            }
        },
        {
            label: 'Transfer DD/DNH',
            command: () => {
                router('/app/application/fresh-registration-transfer-list-diu-daman/QWxs');
            }
        },
        {
            label: 'Eligible Application (Maharashtra State)',
            command: () => {
                router('/app/application/eliglible-application-list');
            }
        },
        {
            label: 'Eligible Application (Other)',
            command: () => {
                router('/app/application/eliglible-application-other-list');
            }
        }
    ];

    const [activeIndex, setActiveIndex] = useState<number>(0);

    const filteredHRitems = HRitems.filter(
        item => item.label && Object.prototype.hasOwnProperty.call(actions, item.label)
    );  

    
    // use Effect method
    useEffect(() => {
        setActions(getAction('Fresh Application'));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

     useEffect(() => {
        if (filteredHRitems.length > 0 && initialTabLabel) {
            const foundIndex = filteredHRitems.findIndex((item) => item.label == initialTabLabel.initialTabLabel);
            setActiveIndex(foundIndex >= 0 ? foundIndex : 0);
        }
    }, [actions, filteredHRitems]);


    return (
        <>
            <TabMenu model={filteredHRitems} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="general-tab inner-tab " />
        </>
    );
};
